// extracted by mini-css-extract-plugin
export default {"link":"link--n-ywN","hiddenText":"hiddenText--yMMbV"};